import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaClock, FaHistory, FaUserCog, FaChartLine, FaUserPlus, FaCalendarCheck, FaMapMarkedAlt, FaTicketAlt } from 'react-icons/fa';
import { logout } from '../../../../utils/api/auth';
import GlobalHeader from '../../../../components/GlobalHeader.jsx';
import '../css/AdminDash.css';

function AdminDash() {
  const nav = useNavigate();

  const handleLogout = () => {
    logout(nav);
  };

  const handleCardClick = (path) => {
    nav(path);
  };

  return (
    <div className="admin-dash-container">
      <GlobalHeader
        title="Admin Dashboard"
        subtitle="Manage events, users, and system settings"
        onLogout={handleLogout}
        backTo="/mainmenu"
        hideBackButton={true}
      />

      <main className="admin-dash-main">
        {/* SECTION 1: EVENT MANAGEMENT */}
        <section className="event-management-section">
          <div className="section-card">
            <div className="section-header">
              <h2>Event Management</h2>
            </div>
            <div className="cards-grid">
              <div 
                className="management-card"
                onClick={() => handleCardClick('/event-approval')}
              >
                <div className="card-icon">
                  <FaClock />
                </div>
                <div className="card-content">
                  <h3>Events Pending Approval</h3>
                  <p>Review and approve new event requests</p>
                </div>
              </div>
              <div 
                className="management-card"
                onClick={() => handleCardClick('/events-history')}
              >
                <div className="card-icon">
                  <FaHistory />
                </div>
                <div className="card-content">
                  <h3>Events History</h3>
                  <p>View complete history of events</p>
                </div>
              </div>
              <div 
                className="management-card"
                onClick={() => handleCardClick('/users')}
              >
                <div className="card-icon">
                  <FaUserCog />
                </div>
                <div className="card-content">
                  <h3>User Management</h3>
                  <p>Manage system users and permissions</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 2: ANALYTICS & REPORTS */}
        <section className="analytics-section">
          <div className="section-card">
            <div className="section-header">
              <h2>Analytics & Reports</h2>
            </div>
            <div className="cards-grid">
              <div 
                className="management-card"
                onClick={() => handleCardClick('/user-growth-analytics')}
              >
                <div className="card-icon">
                  <FaUserPlus />
                </div>
                <div className="card-content">
                  <h3>User Growth Analytics</h3>
                  <p>Track user registration trends</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default AdminDash;
